import React, { useEffect, useState } from 'react';
import { sb } from '../supabaseClient';

interface Empresa { id: string; nome: string; }

interface Props {
  current: string;
  onSelect: (empresaId: string) => void;
}

export function CompanySelector({ current, onSelect }: Props) {
  const [empresas, setEmpresas] = useState<Empresa[]>([]);
  const [role, setRole] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const { data: { user } } = await sb.auth.getUser();
      if (!user) { setLoading(false); return; }

      const { data: profile } = await sb
        .from('profiles')
        .select('role, empresa_id')
        .eq('id', user.id)
        .single();

      if (!profile) { setLoading(false); return; }
      setRole(profile.role);

      if (profile.role === 'cliente') {
        if (profile.empresa_id && !current) {
          localStorage.setItem('concilhe_empresa_id', profile.empresa_id);
          onSelect(profile.empresa_id);
        }
        setLoading(false);
        return;
      }

      if (profile.role === 'admin') {
        const { data } = await sb
          .from('empresas')
          .select('id, nome')
          .eq('ativo', true)
          .order('nome');
        setEmpresas(data || []);
      }

      if (profile.role === 'consultor') {
        const { data } = await sb
          .from('consultor_empresa')
          .select('empresas(id, nome)')
          .eq('consultor_id', user.id);
        const list = (data || [])
          .map((r: any) => r.empresas)
          .filter(Boolean) as Empresa[];
        setEmpresas(list.sort((a, b) => a.nome.localeCompare(b.nome)));
      }

      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <span style={styles.loading}>Carregando…</span>;
  if (role === 'cliente') return null;

  return (
    <div style={styles.wrapper}>
      <label style={styles.label}>Empresa</label>
      <select
        style={styles.select}
        value={current}
        onChange={e => {
          const id = e.target.value;
          localStorage.setItem('concilhe_empresa_id', id);
          onSelect(id);
        }}
      >
        <option value="">— selecione —</option>
        {empresas.map(e => (
          <option key={e.id} value={e.id}>{e.nome}</option>
        ))}
      </select>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: { display: 'flex', alignItems: 'center', gap: 8 },
  label:   { color: '#94a3b8', fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' },
  select: {
    background: '#1e2436',
    border: '1px solid #334155',
    borderRadius: 6,
    color: '#e2e8f0',
    padding: '6px 12px',
    fontSize: 13,
    cursor: 'pointer',
    minWidth: 200,
  },
  loading: { color: '#64748b', fontSize: 13 },
};
